export default __webpack_public_path__ + "static/media/bo.82720b03.svg";